import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { decryption } from "../common/js/utils";
import { applyLoginResult, clearLoginState } from "../utils/auth";
const url = "";

// 设置post请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

//创建axios实例，请求超时时间为120秒
const instance = axios.create({
  timeout: 120000,
});

// 请求发起前拦截
instance.interceptors.request.use(
  (config) => {
    const sid = localStorage.getItem("sid");
    // 登录接口与获取 openid 是登录前的引导请求，此时尚无有效 session，不拼接 sid
    if (
      config.url.search("/login/useOpenIdPWLogin") == -1 &&
      config.url.search("/login/getOpenId") == -1
    ) {
      if (sid) {
        // 仅 sid 存在时拼接，兼容 URL 已带 ? 参数的情况
        config.url += (config.url.indexOf("?") > -1 ? "&" : "?") + "sid=" + sid;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截（请求返回后拦截）
instance.interceptors.response.use(
  (response) => {
    if (response.data.code == 1003) {
      //sid失效，重新登录获取后再次调用原接口
      return new Promise((resolve) => {
        reLogin(resolve, response.config);
      });
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
/**
 * 重新登录后调用原接口
 * @param {*} resolve
 * @param {*} config
 */
function reLogin(resolve, config) {
  if (!localStorage.getItem("userNo")) {
    // 保留已保存账号列表与 openId，否则重登失败后"切换账号"列表会凭空消失
    clearLoginState();
    window.location.replace(url);
    return;
  }

  http
    .post("/api/login/useOpenIdPWLogin", {
      user_no: localStorage.getItem("userNo"),
      password: decryption(localStorage.getItem("pwd")),
      openID: localStorage.getItem("openId"),
    })
    .then((res) => {

      if (res.data.code == 1001) {
        const r = applyLoginResult(res.data.result, res.data.result.sid);
        if (!r.ok) {
          clearLoginState();
          window.location.replace(url);
          return;
        }
        config.url = replaceParamVal(
          config.url,
          "sid",
          localStorage.getItem("sid")
        );
        //调用原接口
        axios(config)
          .then((res) => {
            resolve(res); //将处理后的response传给回调函数
          })
          .catch((err) => {
            Toast("service:" + err.message);
            clearLoginState();
            window.location.replace(url);
          });
      } else {

        clearLoginState();
        window.location.replace(url);
      }
    })
    .catch((err) => {
      Toast(err.message);
      clearLoginState();
      window.location.replace(url);
    });
}

/**
 * 替换url中的参数
 * @param {*} oUrl
 * @param {*} paramName
 * @param {*} replaceWith
 * @returns
 */
function replaceParamVal(oUrl, paramName, replaceWith) {
  var re = eval("/(" + paramName + "=)([^&]*)/gi");
  var nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
  return nUrl;
}

// ---------- 请求去重 ----------
// 两张表：inflight 拦"正在飞的请求"（所有接口都拦，请求回来立即删），
// cooldown 拦"刚成功过的写操作"（只装写操作，请求回来后再留 800ms）。
// 查询类绝不能进冷却：否则"提交成功后立刻刷新"会命中冷却、拿到提交前的旧数据
const inflight = new Map();
const cooldown = new Map();
const COOLDOWN = 800;

// 会改数据的接口：请求成功后再留 800ms 冷却。
// 用白名单而不是给每个方法打标记——改动集中在 service.js，api.js 零改动、也不会漏标
const WRITE_APIS = [
  "/api/login/changePassword",
  "/api/enrollment/student_enrollment",
  "/api/enrollment/cancelEnrollmentById",
  "/api/attendance/addAttendance",
  "/api/attendance/addStudentAttendance",
  "/api/studentLeave/addLeave",
  "/api/studentLeave/recordLeave",
  "/api/serviceClass/joinServiceClass",
  "/api/serviceClass/dropServiceClass",
  "/api/attendance/dutyTeacherAttendance",
];
// 登录(/api/login/useOpenIdPWLogin)和支付(/api/weixinPay/payment)故意不打标记：
// 失败要能立刻重试，且各有自己的页面锁（支付页 isPaying 锁到流程出结果，比 800ms 冷却更严）

/**
 * 请求去重：同一个请求（方法+url+参数）并发只发一次
 * @param {string} method 请求方法 GET/POST
 * @param {string} url 接口地址
 * @param {object|null} data POST 的请求体
 * @param {Function} send 真正发请求的方法
 * @returns {Promise} 命中拦截时返回上一次的 Promise（不会发第二次请求）
 */
function request(method, url, data, send) {
  // url 里此刻还没有 sid（sid 是请求拦截器后加的），key 不受登录态变化影响
  const key = method + " " + url + (data ? " " + qs.stringify(data) : "");
  const isWrite = WRITE_APIS.indexOf(url) !== -1;

  if (inflight.has(key)) return inflight.get(key); // 正在飞：复用同一个 Promise
  if (isWrite && cooldown.has(key)) return cooldown.get(key); // 刚成功过：800ms 内不再发

  const task = send().then(
    (res) => {
      inflight.delete(key);
      if (isWrite) {
        cooldown.set(key, task);
        setTimeout(() => cooldown.delete(key), COOLDOWN);
      }
      return res;
    },
    (err) => {
      // 失败只删在途、不进冷却：否则用户点重试会直接复用上一次已失败的结果，
      // 请求根本没发出去却弹"操作失败"
      inflight.delete(key);
      return Promise.reject(err);
    }
  );

  inflight.set(key, task);
  return task;
}

//按照请求类型对axios进行封装
const http = {
  get(url) {
    return request("GET", url, null, () => instance.get(url));
  },
  post(url, data) {
    return request("POST", url, data, () =>
      instance.post(url, qs.stringify(data))
    );
  },
};
export { http };
